// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ListItem{cursor:pointer;opacity:.72;padding-left:1rem;padding-right:.25rem;padding-top:.75rem;padding-bottom:.75rem;position:relative;font-size:16px;line-height:20px;font-weight:500}.ListItem:hover{--tw-bg-opacity:1;background-color:rgba(246,249,254,var(--tw-bg-opacity))}.ListItem.active{opacity:1}.ListItem.active:before{--tw-bg-opacity:1;background-color:rgba(61,117,228,var(--tw-bg-opacity));height:100%;position:absolute;left:0;top:0;content:\"\";width:.25rem}", ""]);
// Exports
module.exports = exports;
